import { Check, ConfirmModal2, CustomButton, Header, showErrToast } from "components/Common"
import CustomSplitPane from "components/Common/CustomSplitPaneLeft"
import ModalConfigPrinter from "components/Common/Modals/ModalConfigPrinter"
import ModalConfigPrinterPatientVisit from "components/Common/Modals/ModalConfigPrinterPatientVisit"
import { ModuleIds, permissionType, ReportResource, RESULT_STATE_Text } from "constant"
import { getAllOrganizations, getAuthorizePage, getFilePrint, pingToPrintService, sendDataPrint } from "helpers/app-backend"
import { getPatientVisitCollectedList, getPatientVisitWaitingList, getPatientVisitWaitingRequestList } from "helpers/app-backend/testRequest_backend_helper"
import {
  getHisPatient,
} from "helpers/fakebackend_helper"
import {
  GetDataUrlReportPatientVisitConfig,
  GetResourceReportConfig,
} from "helpers/utilities"
import { isEmpty } from "lodash"
import React, { useEffect, useRef, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect, useDispatch, useSelector } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { Row } from "reactstrap"
import {
  ChangeRequestSampleTableSuccess, clearDetailInfoPatientVisit, createNewRequest,
  emptyTestRequestDetail,
  getPatientRequestDetail,
  getPatientRequestWaiting,
  getTestRequestDetail,
  getTestRequestPatientVisitDetail,
  getTestrequestGeneralDetail,
  getTestrequestSamplesDetail,
  getTestrequestTestsDetailSuccess,
  samplePatientVisitChange,
  testPatientVisitChange,
  updateRequestSID
} from "store/actions"
import GroupRequestModal from "./GroupPatient"
import SettingModal from "./Modal/SettingModal"
import LeftFrame from "./PageVisitArea/LeftArea/LeftFrame"
import RightFrame from "./PageVisitArea/RightArea/RightFrame"
import RequestHistoryModal from "./RequestHistoryModal"
import ConfirmModal3 from "components/Common/Modals/ConfirmModal3"

const RESOURCE = ModuleIds.PatientVisit

let sizeWaitingGlobal = 20;
let sizeCollectedGlobal = 20;
let currentTabLisGlobal = '2'
let isLoadFinished = true;
let requestDateGlobal = '';

const PatientVisit = ({
  t,
  patientVisit,
  fetchGetTestrequestGeneralDetail,
  onChangeRequestSampleTable,
  onAddNewRequest,
  onClearDetailInfoPatientVisit,
  fetchGetTestrequestSamplesDetail,
  onGetTestRequestTestsDetailSuccess,
  testChange,
  sampleChange,
  generalSettingObject
}) => {
  const [groupModal, setGroupModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [openReport, setOpenReport] = useState(false)
  const [open, setOpen] = useState(false)
  const [patientDetail, setPatientDetail] = useState({})
  const [patientCollectedDetails, setPatientCollectedDetails] = useState({})
  const [settingModal, setSettingModal] = useState(false)
  const [patientHis, setPatientHis] = useState({})
  const [visitPatient, setVisitPatient] = useState([])
  const [wattingPatient, setWattingPatient] = useState([])
  const [wattingRequest, setWattingRequest] = useState([])
  const [toCollectPatient, setToCollectPatient] = useState([])
  const [disabledAdd, setDisabledAdd] = useState(true)
  const [patientVisitConfig, setPatientVisitConfig] = useState(
    JSON.parse(localStorage.getItem("patientVisitConfig"))
  )
  const [reportResultInfos, setReportResultInfos] = useState({})
  const [disableActionReport, setDisableActionReport] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [filter, setFilter] = useState({})
  const [actionState, setActionState] = useState('')
  const [disableAction, setDisableAction] = useState(false)
  const [actionStateReport, setActionStateReport] = useState('')
  const [page, setPage] = useState(1)
  const [sizeRequestWaiting, setSizeRequestWaiting] = useState(sizeWaitingGlobal)
  const [sizeWaiting, setSizeWaiting] = useState(sizeWaitingGlobal)
  const [sizeCollected, setSizeCollected] = useState(sizeCollectedGlobal)
  const [loadingBarcode, setLoadingBarcode] = useState(false)
  const [modal, setModal] = useState(false)
  const [tabActiveRightFrame, setTabActiveRightFrime] = useState('1')
  const [requestDate, setRequestDate] = useState('')
  const [currentTabLis, setCurrentTabLis] = useState('1')
  const [confirmModal, setConfirmModal] = useState(false)

  const [pagingWaiting, setPagingWaiting] = useState({
    dataSize: "",
    page: "",
    size: "",
    totalPages: ""
  })

  const [pagingCollected, setPagingCollected] = useState({
    dataSize: "",
    page: "",
    size: "",
    totalPages: ""
  })
  const formEl = useRef()
  const [organizations, setOrganizations] = useState([])
  const [activeTab, setActiveTab] = useState('')
  const [historyModal, setHistoryModal] = useState(false)
  const [isRequestChange, setIsRequestChange] = useState(false)
  const [dataWaitingTest, setDataWaitingTest] = useState({})

  useEffect(() => {
    currentTabLisGlobal = currentTabLis
  }, [currentTabLis])

  const getReportResultInfos = async () => {
    const res = await getAuthorizePage(1, "_PatientVisit")
    if (res) {
      setReportResultInfos(res._ReportInfo)
    }
  }
  const dispatch = useDispatch()

  useEffect(() => {
    getReportResultInfos()
    getOrganizations()
    return () => {
      setPatientHis({})
      onClearDetailInfoPatientVisit()
    }
  }, [])

  useEffect(() => {
    setPatientVisitConfig(
      JSON.parse(localStorage.getItem("patientVisitConfig"))
    )
  }, [settingModal])

  useEffect(() => {
    requestDateGlobal = patientVisitConfig?.requestDate ? patientVisitConfig?.requestDate : moment().format("YYYY-MM-DD")
  }, [patientVisitConfig])

  const toggleSetting = () => {
    setSettingModal(prev => !prev)
  }

  const toggleBarcodeSetting = () => {
    setOpen(prev => !prev)
  }

  const toggleReportSetting = () => {
    setOpenReport(prev => !prev)
  }

  const onChangePatient = (name, value) => {
    setPatientDetail({
      ...patientDetail,
      [name]: value,
    })
  }

  const toggle = () => {
    if (!patientVisitConfig?.autoSID) {
      setModal(!modal)
    }
  }

  const { reportInfos } = useSelector(state => ({
    reportInfos: state.Authorization.reportinfo || [],
  }))

  const io1 = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        return;
      }
      sizeWaitingGlobal += 20;
      setSizeRequestWaiting(sizeWaitingGlobal)
    });
  });

  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        return;
      }
      sizeWaitingGlobal += 20;
      setSizeWaiting(sizeWaitingGlobal)
    });
  });

  const io2 = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        return;
      }
      sizeCollectedGlobal += 20;
      setSizeCollected(sizeCollectedGlobal)
    });
  });
  let elEnd1 = document.getElementById(`watch_end_of_document1`)
  let elEnd2 = document.getElementById(`watch_end_of_document2`)
  let elEnd3 = document.getElementById(`watch_end_of_document3`)


  useEffect(() => {
    if (elEnd1) {
      io1.observe(elEnd1)
    }
  }, [elEnd1])

  useEffect(() => {
    if (elEnd2) {
      io.observe(elEnd2)
    }
  }, [elEnd2])

  useEffect(() => {
    if (elEnd3) {
      io2.observe(elEnd3)
    }
  }, [elEnd3])

  const getOrganizations = async () => {
    const res = await getAllOrganizations({ page: 1, size: 0 })
    setOrganizations(res.data)
  }

  useEffect(() => {
    if (organizations.length > 0) {
      onRefreshHandler('2')
    }
  }, [organizations])


  const onSelectPatient = async (e, row, rowIndex) => {
    if (patientDetail) {
      onChangeRequestSampleTable([])
      onClearDetailInfoPatientVisit()
    }
    await fetchGetTestrequestGeneralDetail(row.id, () => {
      setTabActiveRightFrime('2')
      fetchGetTestrequestSamplesDetail(row.id)
    }, ModuleIds.PatientVisit)
    setPatientDetail(row)
    setDisabledAdd(false)
  }

  const onRowClickWaitingRequest = (e, row, rowIndex) => {
    dispatch(getPatientRequestWaiting(row))
    setDataWaitingTest(row)
  }

  const addNewRequest = (request, dataHis) => {
    onAddNewRequest({
      request: request,
      callback: ({ id }) => {
        fetchGetTestrequestGeneralDetail(id)
        let newWattingPatient = wattingPatient.filter(el => {
          return el.patientId != patientDetail.patientId
        })
        let newVisitPatient = visitPatient
        newVisitPatient.unshift(patientDetail)
        setWattingPatient(newWattingPatient)
        setVisitPatient(newVisitPatient)
      },
    })
  }

  const updateRequestSample = payload => {
    onChangeRequestSampleTable(payload)
  }

  useEffect(() => {
    setPatientHis(patientVisit)
    setIsRequestChange(false)
  }, [patientVisit])

  const item = localStorage.getItem("patientVisitConfig")
  const getPatientVisitConfig = () => {
    if (item) {
      try {
        setPatientVisitConfig(JSON.parse(item))
      } catch (error) {

      }
    }
  }
  useEffect(() => {
    getPatientVisitConfig()
    window.addEventListener('storage', getPatientVisitConfig)
    return () => {
      window.removeEventListener('storage', getPatientVisitConfig)
    }
  }, [item])

  const fetchPatientRequestWaitingList = async (searchText, values) => {
    const res = await getPatientVisitWaitingRequestList({
      ...values,
      requestDate: patientVisitConfig?.requestDate ? patientVisitConfig?.requestDate : moment().format("YYYY-MM-DD"),
      search: searchText,
    })
    if (res) {
      setWattingRequest(res.data)
      setPagingWaiting({
        dataSize: res.data?.length || 0,
        page: 1,
        // size: page.size,
        totalPages: 1
      })

      // for (const item of res.data) {
      //   const result = organizations.find(x => x.organizationCode == item.groupCode)
      //   item.organizationName = result?.name || ''
      // }
      // if (res !== null)
      //   setLoading(false)
      // setPagingWaiting({
      //   dataSize: res.totalElements,
      //   page: res.page,
      //   size: page.size,
      //   totalPages: res.totalPages
      // })
      // setWattingPatient([...res.data])
      // setActiveTab('1')
      // if (activeTab == '1') {
      //   if (res && res.data && res.data.length == 1) {
      //     setTabActiveRightFrime(null)
      //     onSelectPatient('', res.data[0])
      //   }
      // }
    }
  }

  const fetchPatientWaitingList = async (searchText, values) => {
    const res = await getPatientVisitWaitingList({ size: sizeWaiting, search: searchText, ...values })
    for (const item of res.data) {
      const result = organizations.find(x => x.organizationCode == item.groupCode)
      item.organizationName = result?.name || ''
    }
    if (res !== null)
      setLoading(false)
    setPagingWaiting({
      dataSize: res.totalElements,
      page: res.page,
      size: page.size,
      totalPages: res.totalPages
    })
    setWattingPatient([...res.data])
    setActiveTab('2')
    if (activeTab == '2' && searchText != '') {
      if (res && res.data && res.data.length == 1) {
        setTabActiveRightFrime(null)
        onSelectPatient('', res.data[0])
      }
    }
  }

  const fetchPatientCollectedList = async (searchText, values) => {
    const res = await getPatientVisitCollectedList({ size: sizeCollected, search: searchText, ...values })
    for (const item of res.data) {
      const result = organizations.find(x => x.organizationCode == item.groupCode)
      item.organizationName = result?.name || ''
    }
    if (res !== null)
      setLoading(false)
    setPagingCollected({
      dataSize: res.totalElements,
      page: res.page,
      size: page.size,
      totalPages: res.totalPages
    })
    setToCollectPatient([...res.data])
    setActiveTab('3')
    if (activeTab == '3' && searchText != '') {
      if (res && res.data && res.data.length == 1) {
        setTabActiveRightFrime(null)
        onSelectPatient('', res.data[0])
      }
    }
  }

  const onRefreshRequestWaitingListWithoutError = async (isAuto = false) => {
    if (currentTabLisGlobal == '1') {
      if (isLoadFinished == false)
        return
      isLoadFinished = false
      const res = await getPatientVisitWaitingRequestList({
        requestDate: requestDateGlobal,
        isAuto,
        search: searchText,
        ...filter
      })
      isLoadFinished = true
      if (res) {
        setWattingRequest(res.data)
      }
    }
  }
  useEffect(() => {
    const interval = setInterval(() => {
      onRefreshRequestWaitingListWithoutError(true)
    }, 10000)
    return () => clearInterval(interval)
  }, [filter, searchText])

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     onRefreshRequestWaitingListWithoutError(true)
  //   }, 10000)
  //   return () => clearInterval(interval)
  // }, [])

  const onRefreshHandler = (activeTab1) => {
    try {
      let check = document.querySelector("#patient-visit-sample-list-table thead th.selection-cell-header input");
      if (check.checked == true) {
        check.click()
      }
    } catch (error) {

    }

    setLoading(true)
    const tab = (activeTab1 || activeTab)
    if (tab == '1') {
      isLoadFinished = true;
      fetchPatientRequestWaitingList(searchText, filter)
      setPatientDetail({})
      dispatch(getPatientRequestWaiting({}))
      setDataWaitingTest({})
      setPatientHis({})
      onClearDetailInfoPatientVisit()
    } else if (tab == '2') {
      fetchPatientWaitingList(searchText, filter)
    } else if (tab == '3') {
      fetchPatientCollectedList(searchText, filter)
    }

  }

  const onSubmitHandler = (searchText, activeTab1) => {
    setSearchText(searchText)
    const tab = (activeTab1 || activeTab)
    if (tab == '1') {
      isLoadFinished = true;
      fetchPatientRequestWaitingList(searchText, filter)
    } else if (tab == '2') {
      fetchPatientWaitingList(searchText, filter)
    } else if (tab == '3') {
      fetchPatientCollectedList(searchText, filter)
    }
  }

  const onSubmitFilterHandler = (e, values, activeTab1) => {
    setFilter(values)
    const tab = (activeTab1 || activeTab)
    if (tab == '1') {
      fetchPatientRequestWaitingList(searchText, values)
    } else if (tab == '2') {
      fetchPatientWaitingList(searchText, values)
    } else if (tab == '3') {
      fetchPatientCollectedList(searchText, values)
    }

  }

  useEffect(() => {
    fetchPatientRequestWaitingList(searchText, filter)
  }, [sizeRequestWaiting])

  useEffect(() => {
    fetchPatientWaitingList(searchText, filter)
  }, [sizeWaiting])

  useEffect(() => {
    fetchPatientCollectedList(searchText, filter)
  }, [sizeCollected])

  // useEffect(() => {
  //   if (!isEmpty(patientDetail)) {
  //     onSelectPatient(null, patientDetail)
  //   }
  // }, [activeTab])

  const onAddRequest = async () => {
    if (!patientDetail.sid && !patientVisitConfig.autoSID) {
      setDisabledAdd(true)
      showErrToast(
        `${t("message:SID is empty", {
          field: `${t(
            "hisConnectorPage:HisConnector"
          )} <span class='text-decoration-underline fw-bold'>SID is empty</span>`,
        })}`
      )
    } else {
      await getHisPatient(patientDetail).then(res => {
        setDisabledAdd(true)
        if (res) {
          let samples = []
          res.tests.forEach(item => {
            samples.push({
              sid: patientVisitConfig.autoSID ? 0 : patientDetail.sid,
              sampleType: item.SampleType,
              sampleTypeName: item.SampleTypeName,
              numberOfLabels: 1,
              collectorUserId: null,
              isCollected: false,
              receiverUserId: null,
              isReceived: false,
              quality: "G",
            })
          })
          updateRequestSample(samples)
          let newTestRequest = []
          let newProfileRequest = []
          for (let i = 0; i < res.tests.length; i++) {
            if (res.tests[i].Children == null) {
              newTestRequest.push({
                testCode: res.tests[i].TestCode,
                testName: res.tests[i].TestName,
                testCategory: res.tests[i].Category,
                sampleType: res.tests[i].SampleType,
              })
            } else {
              newProfileRequest.push({
                profileCode: res.tests[i].TestCode,
                profileCategory: res.tests[i].Category,
              })
              res.tests[i].Children.forEach(element => {
                newTestRequest.push({
                  testCode: element.TestCode,
                  testName: element.TestName,
                  testCategory: element.Category,
                  sampleType: element.SampleType,
                  profileCode: res.tests[i].TestCode,
                })
              })
            }
          }
          const request = {
            individualValues: { ...patientDetail },
            tests: newTestRequest,
            profiles: newProfileRequest,
            samples: samples,
            ...patientDetail,
          }
          addNewRequest(request, { ...res, samples: samples })
        }
      })
    }
  }

  const PrintConfig = async () => {
    const printAppointment = JSON.parse(localStorage.getItem("printConfigReport"))
    if (reportResultInfos.length > 0 && !isEmpty(reportResultInfos[0].uri)) {
      const res = await getFilePrint({
        ...GetDataUrlReportPatientVisitConfig(reportResultInfos, ReportResource.PatientVisit, ""),
        ResultId: patientHis.resultId,
        PatientVisit: patientHis.id,
        RequestDate: patientHis.requestDate,
        PatientId: patientHis.patientId,
        Gender: patientHis.gender,
      })
      try {
        const getPingPrintService = await pingToPrintService();
        if (getPingPrintService.pingTime) {
          const dataSendPrint = await sendDataPrint({
            ...GetDataUrlReportPatientVisitConfig(reportResultInfos, ReportResource.PatientVisit, ""),
            "filePath": `${res.reportUrl}`,
            // "quantity": rowState.numberOfLabels
          })
        } else {
          window.open(process.env.REACT_APP_BASE_ENDPOINT + res?.reportUrl)
        }
      }
      catch {
        window.open(process.env.REACT_APP_BASE_ENDPOINT + res?.reportUrl)
      }
    }
    else {
      console.log('failed')
    }
  }

  const handlePrintResultAppointment = () => {
    PrintConfig()
  }

  const onRequestDateChange = (value) => {
    setRequestDate(value)
  }

  const openHistory = async () => {
    setHistoryModal(true)
  }

  const onRequestChange = (isChange = true, value, type) => {
    setIsRequestChange(isChange)
  }

  let sampleMessageWarning = <></>
  let testMessageWarning = <></>
  if (sampleChange.length > 0) {
    sampleMessageWarning = <>
      <div><b>{t('testRequestPage:Sample Collect')}</b></div>
      {sampleChange
        .filter(item => item.state == RESULT_STATE_Text.Submitted || item.state == RESULT_STATE_Text.RDS)
        .map((item, index) => <div key={index}>{`${item.sampleTypeName} - ${item.sampleType}`}</div>)}</>
  }

  if (testChange.length > 0) {
    testMessageWarning = <>
      <div><b>{t('testRequestPage:Test Delete')}</b></div>
      {testChange
        .filter(item => item.state == RESULT_STATE_Text.Submitted || item.state == RESULT_STATE_Text.RDS)
        .map((item, index) => <div key={index}>{`${item.code} - ${item.name}`}</div>)}</>
  }


  const height = window.innerHeight > 785 ? `calc(${window.innerHeight}px - 110px)` : '800px'

  return (
    <React.Fragment>
      <div id="result-header-detail">
        <Row>
          <ModalConfigPrinterPatientVisit open={openReport} onClose={(state) => {
            setDisableActionReport(false)
            setOpenReport(false)
          }}
            disableAction={disableActionReport}
            stateAction={actionStateReport}
            resource={GetResourceReportConfig(reportResultInfos)}
            onPreviewClick={(state) => { onPreviewHandler(state) }}
            onPrintClick={(state) => { onPrintHandler(state) }}
            onExportClick={(state) => { onExportHandler(state) }}
          />
          <ModalConfigPrinter open={open} onClose={(state) => {
            setDisableAction(false)
            setOpen(false)
          }}
            disableAction={disableAction}
            stateAction={actionState}
            resource={GetResourceReportConfig(reportInfos)}
            onPreviewClick={(state) => { onPreviewHandler(state) }}
            onPrintClick={(state) => { onPrintHandler(state) }}
            onExportClick={(state) => { onExportHandler(state) }}
          />
          <div className="d-flex p-2 bg-white border-bottom">
            <div className="col-6">
              <Header
                title={t("testRequestPage:Process management")}
                resource={RESOURCE}
                subtitle={t("Patient Visit")}
              />
            </div>
            <div className="d-flex col-6 gap-1 justify-content-end">
              {currentTabLis != '1' &&
                <Check permission={permissionType.U} resource={RESOURCE}>
                  <CustomButton
                    text={t("common:Save")}
                    type="submit"
                    isEdit
                    color="success"
                    className="save-user button-width"
                    disabled={!isRequestChange}
                    onClick={() => {
                      // formEl.current.onSave()
                      setConfirmModal(true)
                    }}
                  >
                    {t("common:Save")}
                  </CustomButton>
                </Check>}
              <Link
                to={`/PatientGroup`}
              >
                <CustomButton
                  outline
                  text={t("testRequestPage:Patient Group")}
                  color="success"
                  className="save-user button-width"
                  onClick={() => {
                    setGroupModal(true)
                  }}
                >
                  <i className="mdi mdi-account-multiple px-1"></i>
                  {t("testRequestPage:Patient Group")}
                </CustomButton>
              </Link>
              <CustomButton
                className="loading-spin-hover"
                color="secondary"
                outline
                onClick={openHistory}
              >
                <i className="fas fa-history"></i>
              </CustomButton>

              {/* Phiếu hẹn trả kết quả */}
              {/* <CustomButton
                className="loading-spin-hover"
                color="secondary"
                outline
                onClick={toggleReportSetting}
              >
                <i className="fa fa-file"></i>
              </CustomButton> */}
            </div>
          </div>
        </Row >
      </div >
      <div className="row position-relative" style={{ height: height, paddingTop: 5 }}>
        {loadingBarcode &&
          <div className="position-absolute h-100 w-100" style={{ zIndex: 10, backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
            <div className="w-100 h-100"><div className="text-center" style={{ marginTop: 50 }}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
            </div>
          </div>
        }
        <CustomSplitPane
          LeftFrame={() => (
            <RightFrame
              onSelectPatient={onSelectPatient}
              onRowClickWaitingRequest={onRowClickWaitingRequest}
              patientDetail={patientDetail}
              onRefresh={onRefreshHandler}
              toggle={toggle}
              toggleBarcodeSetting={toggleBarcodeSetting}
              onSubmit={onSubmitHandler}
              onSubmitFilter={onSubmitFilterHandler}
              loading={loading}
              visitPatient={visitPatient}
              wattingRequest={wattingRequest}
              wattingPatient={wattingPatient}
              toCollectPatient={toCollectPatient}
              pagingWaiting={pagingWaiting}
              pagingCollected={pagingCollected}
              requestDate={requestDate}
              patientVisitTab={activeTab}
              generalSettingObject={generalSettingObject}
              onChangeTabTypeLis={val => {
                setCurrentTabLis(val)
                onChangeRequestSampleTable([])
                setPatientHis({})
                onClearDetailInfoPatientVisit()
                setPatientDetail({})
                onGetTestRequestTestsDetailSuccess({ tests: [] })
              }}
              onChangeTab={(val) => {
                setTabActiveRightFrime(val)
              }}
              onSelectBarcode={e => {
                setLoadingBarcode(e)
              }}
            />
          )}
          RightFrame={() => (
            <LeftFrame
              patientDetail={patientDetail}
              patientCollectedDetails={patientCollectedDetails}
              toggle={toggleSetting}
              onRefresh={onRefreshHandler}
              toggleReportSetting={toggleReportSetting}
              onChangePatient={onChangePatient}
              onClickAddRequest={onAddRequest}
              patientHis={patientHis}
              disabledAdd={disabledAdd}
              config={patientVisitConfig}
              ref={formEl}
              onRefreshInfo={onSelectPatient}
              tabActive={tabActiveRightFrame}
              onDateChange={onRequestDateChange}
              patientVisitTab={activeTab}
              onRequestChange={onRequestChange}
              currentTabLis={currentTabLis}
              dataWaitingTest={dataWaitingTest}
              clearPatientDetail={() => {
                setPatientDetail({})
              }}
            />
          )}
          InitialSize={66}
        />
      </div>
      <SettingModal
        modal={settingModal}
        toggle={() => {
          setSettingModal(false)
        }}
      />
      <GroupRequestModal
        modal={groupModal}
        toggle={() => {
          setGroupModal(false)
        }}
      />
      <RequestHistoryModal
        modal={historyModal}
        data={patientDetail}
        search={filter}
        toggle={() => setHistoryModal(prev => !prev)}
      />

      <ConfirmModal3
        modal={confirmModal}
        title={t("common:Update")}
        message={
          <div>
            {sampleMessageWarning}
            {testMessageWarning}
          </div>
        }
        style={{ maxHeight: '230px' }}
        onToggle={() => { setConfirmModal(prev => !prev) }}
        onConfirm={() => {
          formEl.current.onSave()
          setConfirmModal(prev => !prev)
        }}
        btnConfirmText={t("common:Save")}
        isEdit
      />
      {/* <ChangeSIDModal
        formEl={formEl}
        modal={modal}
        isEdit={false}
        onValidSubmit={handleValidSubmit}
        toggle={toggle}
        data={patientDetail}
      /> */}
    </React.Fragment>
  )
}

const mapStateToProps = ({ testRequest, generalSetting }) => ({
  patientVisit: testRequest.patientVisit,
  testChange: testRequest.testChange,
  sampleChange: testRequest.sampleChange,
  generalSettingObject: generalSetting.generalSettingObject,
})

const mapDispatchToProps = dispatch => ({
  onGetTestRequestDetail: requestId =>
    dispatch(getTestRequestDetail(requestId)),
  onGetTestRequestPatientVisitDetail: requestId =>
    dispatch(getTestRequestPatientVisitDetail(requestId)),
  onGetPatientRequestDetail: individualId =>
    dispatch(getPatientRequestDetail(individualId)),
  onAddNewRequest: payload => dispatch(createNewRequest(payload)),
  onChangeRequestSampleTable: payload =>
    dispatch(ChangeRequestSampleTableSuccess(payload)),
  fetchGetTestrequestGeneralDetail: (requestId, callback, type) =>
    dispatch(getTestrequestGeneralDetail(requestId, callback, type)),
  onClearDetailInfoPatientVisit: () =>
    dispatch(clearDetailInfoPatientVisit()),
  onUpdateSampleId: (payload) => dispatch(updateRequestSID(payload)),
  fetchGetTestrequestSamplesDetail: requestId => dispatch(getTestrequestSamplesDetail(requestId)),
  onEmptyTestRequestDetail: payload =>
    dispatch(emptyTestRequestDetail(payload)),
  onGetTestRequestTestsDetailSuccess: payload =>
    dispatch(getTestrequestTestsDetailSuccess(payload)),
  onTestPatientVisitChange: (payload) => dispatch(testPatientVisitChange(payload)),
  onSamplePatientVisitChange: (payload) => dispatch(samplePatientVisitChange(payload))
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation(["partyPage", "message", "common", "testRequestPage"])(PatientVisit)))
